/**
 * Shared keyboard focus treatment for Specra interactive primitives.
 *
 * Single source of truth so hand-rolled `<a>`/`<button>` tiles can't drift
 * from `SpecraButton`.
 */ export const specraFocusRing = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background';
